import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import AuthCallback from "presentation/components/Auth/Callback";
import Login from "presentation/components/Auth/Login";
import TimesheetAnalysis from "presentation/components/Timesheet/TimesheetAnalysis";
import ClientFormPage from "presentation/pages/ClientFormPage";
import ClientGridPage from "presentation/pages/ClientGridPage";
import DashboardPage from "presentation/pages/DashboardPage";
import EmployeeFormPage from "presentation/pages/EmployeeFormPage";
import EmployeeGridPage from "presentation/pages/EmployeeGridPage";
import ExportPage from "presentation/pages/ExportPage";
import InvoicePage from "presentation/pages/InvoicePage";
import NotFoundPage from "presentation/pages/NotFoundPage";
import ProjectFormPage from "presentation/pages/ProjectFormPage";
import ProjectGridPage from "presentation/pages/ProjectGridPage";
import PurchaseOrderFormPage from "presentation/pages/PurchaseOrderFormPage";
import PurchaseOrderGridPage from "presentation/pages/PurchaseOrderGridPage";
import ReportsPage from "presentation/pages/Reports";
import SettingPage from "presentation/pages/SettingPage";
import TimesheetDocumentsPage from "presentation/pages/TimesheetDocumentsPage";
import TimesheetFormPage from "presentation/pages/TimesheetFormPage";
import TimesheetGridPage from "presentation/pages/TimesheetGridPage";
import TripSheetGridPage from "presentation/pages/TripSheetGridPage";
import UserPage from "presentation/pages/UserPage";
import VacationPage from "presentation/pages/VacationPage";
import WebsitePage from "presentation/pages/Website";
import DocumentRegulationsGridPage from "presentation/pages/DocumentRegulationsGridPage";
import DocumentTutorialsGridPage from "presentation/pages/DocumentTutorialsGridPage";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/saga-blue/theme.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteTracker from "RouterTrack";
import "./App.css";
import Home from "./presentation/pages/Home";
import ExpensePage from "presentation/pages/ExpensePage";
import LinkedinCardsGridPage from "presentation/pages/LinkedinCardsGridPage";
import RespondToFormPage from "presentation/pages/RespondToFormPage";
import NimberFormsPage from "presentation/pages/NimberFormsPage";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={process.env.REACT_APP_BASENAME || "/"}>
        <>
          <RouteTracker>
            {" "}
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/respondToForm/:slug" element={<RespondToFormPage/>}/>
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/" element={<Home />}>
                <Route path="/dashboards" element={<DashboardPage />} />
                <Route path="/formsTemplate" element={<NimberFormsPage />} />

                <Route path="/employees" element={<EmployeeGridPage />} />
                <Route path="/employees/new" element={<EmployeeFormPage />} />
                <Route
                  path="/employees/edit/:id"
                  element={<EmployeeFormPage />}
                />
                <Route path="/timesheets" element={<TimesheetGridPage />} />
                <Route
                  path="/timesheets/edit/:id"
                  element={<TimesheetFormPage />}
                />
                <Route
                  path="/timesheets/attachment/:id"
                  element={<TimesheetDocumentsPage />}
                />
                <Route
                  path="/timesheets/view/:id/:employeeId"
                  element={<TimesheetFormPage isDisable={true} />}
                />

                <Route
                  path="/timesheets/analysis/:year/:month"
                  element={<TimesheetAnalysis />}
                />
                {/* <Route
                  path="/timesheets/reports/:year/:month"
                // element={<TimesheetReportUpload />}
                /> */}

                <Route path="/tripsheets" element={<TripSheetGridPage />} />
                <Route path="/vacations" element={<VacationPage />} />

                {/*usar como base para a criação do elemento*/}
                <Route path="/clients" element={<ClientGridPage />} />
                <Route path="/clients/new" element={<ClientFormPage />} />
                <Route path="/clients/edit/:id" element={<ClientFormPage />} />

                {/*Linkedin Cards*/}
                <Route path="/openPositions" element={<LinkedinCardsGridPage />} />
          
                <Route path="/projects" element={<ProjectGridPage />} />
                <Route path="/projects/new" element={<ProjectFormPage />} />
                <Route
                  path="/projects/edit/:id"
                  element={<ProjectFormPage />}
                />

                <Route
                  path="/purchaseOrders"
                  element={<PurchaseOrderGridPage />}
                />
                <Route
                  path="/purchaseOrders/new"
                  element={<PurchaseOrderFormPage />}
                />
                <Route
                  path="/purchaseOrders/edit/:id"
                  element={<PurchaseOrderFormPage />}
                />
                
                <Route path="/tutorials" element={<DocumentTutorialsGridPage />} />
                <Route path="/regulations" element={<DocumentRegulationsGridPage />} /> 

                <Route path="/invoices" element={<InvoicePage />} />
                <Route path="/expenses" element={<ExpensePage />} />

                <Route path="/reports" element={<ReportsPage />} />
                {/* <Route path="/reports-menu" element={<ReportsMenu />} /> */}
                <Route path="/exports" element={<ExportPage />} />

                <Route path="/settings" element={<SettingPage />} />
                <Route path="/users" element={<UserPage />} />
                <Route path="/website" element={<WebsitePage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Routes>
          </RouteTracker>
        </>

        <ReactQueryDevtools initialIsOpen={false} />
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
